import { Text } from "@certn/cascadia-react";
import { SelectedCheckAddOn } from "../../../pages/order/OrderContext";
import { css } from "@emotion/css";
import { formatNullableCurrency } from "../../../utils/formatNullableCurrency";

type AddOnOrderSummaryProps = {
  add_on_options?: SelectedCheckAddOn[];
  check_arguments?: Record<string, unknown>;
  currency?: string;
  canViewClientPortalPricing: boolean;
};

export const AddOnOrderSummary = ({
  add_on_options,
  check_arguments,
  currency,
  canViewClientPortalPricing,
}: AddOnOrderSummaryProps) => {
  if (!add_on_options || add_on_options.length === 0) return null;

  return (
    <div>
      {add_on_options
        .filter((addon) => !!check_arguments?.[addon.key])
        .map((addon) => (
          <div
            className={css({
              paddingTop: 8,
              display: "flex",
              justifyContent: "space-between",
            })}
            key={addon.key}
          >
            <Text as="div">{addon.name}</Text>
            {canViewClientPortalPricing && addon.price && (
              <Text as="div" style="global/metric-detail" color="text-weak">
                {formatNullableCurrency(addon.price, {
                  currency: addon.currency || currency,
                  locale: "en-US",
                  fallback: null,
                })}
              </Text>
            )}
          </div>
        ))}
    </div>
  );
};
